import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-9e6dc9e3.js';
import 'classnames';

var Facebook = createSvgIcon(React__default.createElement("path", { clipRule: "evenodd", d: "M20.007 3H3.993C3.44475 3 3 3.44475 3 3.993V20.007C3 20.556 3.44475 21 3.993 21H12.6135V14.0295H10.2668V11.3138H12.6135V9.3075C12.6135 6.98325 14.034 5.71875 16.1078 5.71875C17.1015 5.71875 17.9557 5.7915 18.2047 5.8245V8.2545H16.764C15.639 8.2545 15.42 8.79525 15.42 9.58275V11.316H18.108L17.7593 14.0385H15.42V21H20.0063C20.556 21 21 20.556 21 20.007V3.993C21 3.44475 20.556 3 20.007 3", fillRule: "evenodd" }), 'Facebook');

export { Facebook };
